// src/button.tsx
import { forwardRef } from "react";

// src/class-names.ts
function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(" ") || void 0;
}

// src/button.module.css
var button_default = {
  button: "button_button",
  primary: "button_primary",
  primaryGhost: "button_primaryGhost",
  ghost: "button_ghost",
  subtle: "button_subtle",
  icon: "button_icon"
};

// src/button.tsx
import { jsx } from "react/jsx-runtime";
var variantClassNames = {
  default: void 0,
  primary: joinClassNames(button_default.primary, "primary"),
  "primary-ghost": joinClassNames(button_default.primaryGhost, "primary-ghost"),
  ghost: joinClassNames(button_default.ghost, "ghost"),
  subtle: joinClassNames(button_default.subtle, "subtle")
};
var sizeClassNames = {
  default: void 0,
  icon: joinClassNames(button_default.icon, "icon-btn")
};
var Button = forwardRef(function Button2({ className, type = "button", variant = "default", size = "default", ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      ref,
      type,
      className: joinClassNames(
        button_default.button,
        variantClassNames[variant],
        sizeClassNames[size],
        className
      ),
      ...props
    }
  );
});

// src/form-controls.tsx
import { forwardRef as forwardRef2 } from "react";

// src/form-controls.module.css
var form_controls_default = {
  control: "form_controls_control",
  textarea: "form_controls_textarea",
  select: "form_controls_select"
};

// src/form-controls.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Input = forwardRef2(function Input2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx2("input", { ref, className: joinClassNames(form_controls_default.control, className), ...props });
});
var Textarea = forwardRef2(function Textarea2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx2("textarea", { ref, className: joinClassNames(form_controls_default.control, form_controls_default.textarea, className), ...props });
});
var Select = forwardRef2(function Select2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx2("select", { ref, className: joinClassNames(form_controls_default.control, form_controls_default.select, className), ...props });
});

// src/visually-hidden.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
function VisuallyHidden({ children, className, ...props }) {
  return /* @__PURE__ */ jsx3("span", { className: joinClassNames("sr-only", className), ...props, children });
}
export {
  Button,
  Input,
  Select,
  Textarea,
  VisuallyHidden
};
